import axios from 'axios';
const BASE_URL = 'https://api.in-edit.lu';
//const BASE_URL = 'http://localhost:4556';

export default axios.create({
    baseURL: BASE_URL,
});

export const privateApi = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});
